/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_CloseInputs */

const en_us2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pt_br2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const es_419_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const pt_pt2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const fr_fr2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_de2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_it2_share_video_close = /** @type {(inputs: Share_Video_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Share_Video_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_close = /** @type {((inputs?: Share_Video_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_close(inputs)
	if (locale === "es-419") return es_419_share_video_close(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_close(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_close(inputs)
	if (locale === "de-DE") return de_de2_share_video_close(inputs)
	if (locale === "it-IT") return it_it2_share_video_close(inputs)
	return en_us2_share_video_close(inputs)
});
export { share_video_close as "share.video_close" }